module.exports = __webpack_public_path__ + "media/images/flags/um-5ff75fd90c5718a9b3ecb8dc00421429.svg";